export default () => ({
	background: null,
	content: null,
	init() {
		this.background = this.$root.querySelector(".background");
		this.content = this.$root.querySelector(".main-content");

		this.backgroundSize();
	},
	backgroundSize() {
		let height = this.content.getBoundingClientRect().height;
		this.background.style.height = height + "px";
	},
});
